
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsForm',
  components: { DesignContentLayout },
  data() {
    return {
      ACTIVE_OPTIONS: [
        { label: '라디오 Radio 1', value: 1 },
        { label: '라디오 Radio 2', value: 2 }
      ],
      DISABLED_OPTIONS: [
        { label: '라디오 Radio 1', value: 1, disabled: true },
        { label: '라디오 Radio 2', value: 2, disabled: true }
      ],
      valueActive: 1,
      valueDisabled: 1,
      checkboxChecked: true,
      checkboxUnchecked: false,
      checkboxCheckedDisabled: true,
      checkboxUncheckedDisabled: false,
      searchInput: null,
      isSubmitStatus: false,
      CHECKBOX_TOGGLE_OPTIONS: {
        true: { label: '체크박스 토글', value: true },
        false: { label: 'CheckBox Toggle', value: false },
        disabled_true: { label: '체크박스 토글', value: true },
        disabled_false: { label: 'CheckBox Toggle', value: false }
      },
      TOGGLE_OPTIONS: {
        true: { label: '토글', value: true },
        false: { label: 'Toggle', value: false },
        disabled_true: { label: '토글', value: true },
        disabled_false: { label: 'Toggle', value: false }
      }
    };
  },
  methods: {
    cancel() {
      this.searchInput = null;
      this.isSubmitStatus = false;
    },
    submit() {
      this.isSubmitStatus = this.searchInput?.length > 0;
    }
  }
};
